module.exports = __webpack_public_path__ + "img/galery-brazo-extensor-1.e8c9011b.jpg";